// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Refresh = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 5a2 2 0 0 0-2 2v3H4V7a3 3 0 0 1 3-3h6v1zM11 13a2 2 0 0 0 2-2V8h1v3a3 3 0 0 1-3 3H5v-1z"
    />
    <path stroke="currentColor" d="m7 16-2.5-2.5L7 11M11 2l2.5 2.5L11 7" />
  </svg>
);
const ForwardRef = forwardRef(Refresh);
export default ForwardRef;
